import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import { AceEditor } from '@jupiterone/jupiter-web-toolkit/src/util/loadReactAce';
import aceJSS from '@jupiterone/jupiter-web-toolkit/src/styles/AceEditor.styles';
import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit/src/theme/types';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    editor: {
      '&.ace_editor': {
        margin: `0 auto`,
        borderTop: `solid 1px ${theme.palette.coolGrey[100]}`,
        borderBottom: `solid 1px ${theme.palette.coolGrey[100]}`,
        color: theme.palette.text.primary,
        fontFamily: `'Ubuntu Mono', monospace`,
        fontSize: 16,
        ...aceJSS(theme),
      },
    },
  })
);

interface Props {
  value: string;
  onChange?: (value: string) => void;
  readOnly?: boolean;
  wrap?: boolean;
}

const JSONEditor = ({ onChange, value, readOnly, wrap }: Props) => {
  const classes = useStyles();
  // For editorProps, see https://github.com/securingsincity/react-ace/issues/29
  return (
    <AceEditor
      data-testid="aceEditor"
      className={classes.editor}
      mode="json"
      width="100%"
      height="100%"
      theme={'tomorrow'}
      onChange={onChange}
      value={value}
      showGutter={true}
      minLines={10}
      readOnly={readOnly}
      wrapEnabled={wrap}
      editorProps={{
        $blockScrolling: Infinity,
      }}
      onLoad={(editor) => {
        editor.renderer.setPadding(10);
        editor.renderer.setScrollMargin(10);
      }}
    />
  );
};

export default JSONEditor;
